import useTodaysAppointments from '@hooks/useTodaysAppointments';

/** Return the earliest of upcoming appointments that will occur within 24 hours */
export default function useUpcomingAppointment() {
  const { appointments, refetchAppointments } = useTodaysAppointments();
  const now = new Date();

  const upcoming = appointments.find((a) => {
    // call started but not finished yet
    if (a.clin_start && !a.clin_end) return a;
    // or the next appointment due to start
    if (a.appt_start_date > now) return a;

    return false;
  });

  return {
    upcomingAppointment: upcoming,
    refetchUpcomingAppointment: refetchAppointments
  };
}
